import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import {
  OccupationProfileModel,
  OccupationQuickMatchModel
} from '@cpd-app/core-module/models';

export const occupationFeatureKey = 'occupation';

export const occupationsByDemandAdapter: EntityAdapter<OccupationQuickMatchModel> =
  createEntityAdapter<OccupationQuickMatchModel>({
    selectId: (occupationQuickMatch: OccupationQuickMatchModel) =>
      occupationQuickMatch.onetCode,
    sortComparer: false
  });

export interface OccupationState
  extends EntityState<OccupationQuickMatchModel> {
  occupationProfileModel: OccupationProfileModel;
}

export const initialOccupationState: OccupationState =
  occupationsByDemandAdapter.getInitialState({
    occupationProfileModel: null
  });

export const { selectAll, selectEntities, selectIds, selectTotal } =
  occupationsByDemandAdapter.getSelectors();
